import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AppRouter } from "@/zapi-frontend/app/providers/router";
import { useSentry } from "../shared/hooks/useSentry";
import { useIdentifySessionByEmail } from "@/zapi-frontend/app/providers/analytics";
import { initializeOrganizationHandling } from "@/zapi-frontend/shared/api/organizationInterceptor";
import { initializeLocalStorage } from "../shared/local-storage/initializeLocalStorage";
import { useNotificationSSE } from "@/zapi-frontend/features/Notifications";
import { CookieConsentModal } from "@/zapi-frontend/widgets/CookieConsentModal";
import { useUserLanguageSync } from "@/zapi-frontend/shared/i18n/useProjectLanguageSync";
import { FigmaTypographyVariantsProvider, REDESIGN_TYPOGRAPHY_VARIANTS } from "@libs/zapi-ui/custom";
import { Toaster as DesignSystemToaster } from "@libs/zapi-ui/ds/components/toast";

export function App() {
  const { t } = useTranslation("common");
  useSentry();
  useIdentifySessionByEmail();
  useNotificationSSE();
  useUserLanguageSync();

  useEffect(() => {
    initializeOrganizationHandling();
    initializeLocalStorage();
  }, []);

  return (
    <FigmaTypographyVariantsProvider value={REDESIGN_TYPOGRAPHY_VARIANTS}>
      <div className="min-h-screen">
        <AppRouter />
        <CookieConsentModal />
      </div>
      <DesignSystemToaster closeLabel={t("close")} />
    </FigmaTypographyVariantsProvider>
  );
}

export default App;
